export const LOGIN = `auth/login`;
export const REGISTER = `auth/register`;
export const LOGOUT = `auth/logout`;
export const INITIATE_PASSWORD_RESET = `auth/initiate-password-reset`;
export const RESET_PASSWORD = `auth/reset-passowrd`;